import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySearchTranslations = wrapTranslationsSchema({
	name: 'BuyEasySearchTranslations',
	title: 'Search Translations',
	sanityId: 'buyeasy-search',
	fields: {
		globalPlaceholder: 'Suppliers search',
		title: 'Didn’t find a suitable supplier?',
		viewHcpHco: 'View HCP/HCO',
		onboarding: 'Supplier Onboarding Process',
		noResultsGeneral: `Your search for **'{searchQuery}'** yielded no results.`,
		companyCodeNotSelected:
			'You do not currently have a Company Code selected or you have selected multiple Company Codes. The Suppliers shown may not be Preferred for your usage. Please select a single Company Code to ensure proper results.',
	},
});
